import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { portalAPI } from '../../services/api';
import { Mail, ArrowRight, Loader } from 'lucide-react';

const PortalLogin = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [stage, setStage] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      setStage('exchanging');
      portalAPI.exchange(token).then(res => {
        const { token: jwt, customer } = res.data;
        localStorage.setItem('portalToken', jwt);
        localStorage.setItem('portalCustomer', JSON.stringify(customer));
        navigate('/portal/dashboard');
      }).catch(err => {
        setErrorMsg(err?.response?.data?.message || 'Link expired or invalid');
        setStage('error');
      });
    }
  }, [params, navigate]);

  const requestLink = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await portalAPI.requestLink(email);
      setStage('sent');
    } catch {
      setErrorMsg('Could not send link, try again');
      setStage('error');
    }
  };

  return (
    <div style={page}>
      <div style={panel}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#f97316' }}>MeccaFlex</div>
          <div style={{ color: '#a1a1aa', marginTop: 4 }}>Customer Portal</div>
        </div>

        {stage === 'exchanging' && (
          <div style={{ textAlign: 'center', color: '#a1a1aa' }}>
            <Loader size={32}/> Verifying your link…
          </div>
        )}

        {stage === 'sent' && (
          <div style={{ textAlign: 'center' }}>
            <Mail size={48} color="#10b981" style={{ marginBottom: 12 }} />
            <h2 style={{ margin: 0 }}>Check your inbox</h2>
            <p style={{ color: '#a1a1aa' }}>We sent a secure sign-in link to <strong>{email}</strong>. It expires in 15 minutes.</p>
          </div>
        )}

        {(stage === 'idle' || stage === 'error') && (
          <form onSubmit={requestLink}>
            <p style={{ color: '#a1a1aa', textAlign: 'center', marginBottom: 16 }}>
              Enter your email — we'll send you a secure sign-in link. No password needed.
            </p>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@company.com" style={input} autoFocus />
            <button type="submit" style={primaryBtn}>
              Send sign-in link <ArrowRight size={16}/>
            </button>
            {stage === 'error' && <div style={{ color: '#ef4444', textAlign: 'center', marginTop: 12, fontSize: 13 }}>{errorMsg}</div>}
          </form>
        )}
      </div>
    </div>
  );
};

const page = { minHeight: '100vh', background: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, color: '#fafafa' };
const panel = { background: '#111', border: '1px solid #27272a', borderRadius: 12, padding: 32, width: '100%', maxWidth: 420 };
const input = { width: '100%', padding: '12px 14px', background: '#18181b', border: '1px solid #27272a', borderRadius: 8, color: '#fafafa', fontSize: 14, marginBottom: 12, boxSizing: 'border-box' };
const primaryBtn = { width: '100%', padding: '12px', background: '#f97316', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8 };

export default PortalLogin;
